import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import AuthStore from '../../Auth/AuthStore';
import MainStore from '../../../MainStore';
import SchedulleStore from './SchedulleStore'

const SaleSchedulleEditDialog = observer(class SaleSchedulleEditDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };
        this.handleSave = this.handleSave.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleClose() {
        SchedulleStore.closeSaleSchedulleEditDialog();
    }

    handleSelect(result) {
        this.setState({ resultId: result.id, result: result });
    }

    handleSave() {
        var scope = this;
        MainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Schedulle/EditSaleTime', {
            method: 'POST',
            body: JSON.stringify({ id: SchedulleStore.getSale.id, minutes: SchedulleStore.getMinutes, date: SchedulleStore.getSale.date, saleId: SchedulleStore.getSale.saleId, comment: SchedulleStore.getSale.comment }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                AuthStore.openLogin();
                MainStore.setMaskUnvisible();
                //scope.startSearch(); Перезагрузить доску?
            }
            else {
                res.json().then((result) => {
                    MainStore.setMaskUnvisible();
                    SchedulleStore.closeSaleSchedulleEditDialog();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleChange = name => evt => {
        if (name === 'minutes') {
            SchedulleStore.setMinutes(evt.target.value);
        }
        else {
            var sale = SchedulleStore.getSale;
            sale[name] = evt.target.value;
            SchedulleStore.setSale(sale);
        }
    }

    formatDate(d) {
        var date = new Date(d);
        var month = (date.getMonth() + 1);
        if (month < 10) month = '0' + month;

        var day = date.getDate();
        if (day < 10) day = '0' + day;

        return date.getFullYear() + '-' + month + '-' + day;
    }

    render() {
        return (
            <Dialog
                onClose={this.handleClose}
                aria-labelledby="customized-dialog-title"
                open={SchedulleStore.isSaleSchedulleEditDialogOpen}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                    {SchedulleStore.getSale.saleNumber + ' ' + SchedulleStore.getSale.saleCaption}
                </DialogTitle>
                <DialogContent dividers>
                    <Typography>
                        <TextField required
                            id="standard-required"
                            label="Время"
                            defaultValue=""
                            fullWidth
                            margin="normal"
                            autoFocus={true}
                            value={SchedulleStore.getMinutes}
                            onChange={this.handleChange('minutes')} />
                    </Typography>
                    <Typography>
                        <TextField required
                            id="standard-required"
                            label="Дата"
                            defaultValue=""
                            fullWidth
                            type="date"
                            margin="normal"
                            value={this.formatDate(SchedulleStore.getSale.date)}
                            onChange={this.handleChange('date')} />
                    </Typography>
                    <Typography>
                        <TextField required
                            id="standard-required"
                            label="Комментарий"
                            defaultValue=""
                            fullWidth
                            multiline
                            margin="normal"
                            value={SchedulleStore.getSale.comment}
                            onChange={this.handleChange('comment')} />
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleSave} color="primary">
                        Сохранить
                     </Button>
                </DialogActions>
            </Dialog>
        );
    }
});

export default SaleSchedulleEditDialog;